import {Model} from 'vue-mc';


/**
 * Task model
 */
export default class GetFileModel extends Model {

  defaults() {
    return {
    }
  }

  routes() {
    return {
      getFile: "interpreter/getDocument",
      getJobSlip: "jobs/getJobSlip"
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/GetFileModel.js